import React, { Component } from 'react';
import {Route, Switch} from 'react-router-dom';
import { runInThisContext } from 'vm';
import  SignInContainer from './../containers/SignInContainer'
import { RequestPasswordReset } from './../components/Users'
import { ResetsContainer, InvitesContainer } from './../containers'

class unAuthRoutes extends Component {
    render(){
        return(
            <React.Fragment>
                <Route path='/reset/request-reset' render={ (props) => <RequestPasswordReset {...props}/>} />
                <Route path='/reset/:resetId' render={(props) => <ResetsContainer {...props} />} />
                <Route path='/invites/:inviteId' render={(props) => <InvitesContainer {...props} />} />
                <Route path='/login' render={ (props) => ( <SignInContainer {...props} /> )} />
                <Route path='/signin-username' render={ (props) => ( <SignInContainer {...props} /> )} />
            </React.Fragment>
        )
    }
}

export default unAuthRoutes;


// WEBPACK FOOTER //
// ./src/config/MainUnauths.js